import AuditingToolReportActionTypes from './auditing-tool-report.types';

/** ***************** GET AUDITING TOOL REPORT START *********************** */
export const getAuditingToolReportStart = (getData: any) => ({
	type: AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_START,
	payload: getData,
});

export const getAuditingToolReportSuccess = (successData: any) => ({
	type: AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getAuditingToolReportFailure = (failureData: any) => ({
	type: AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getAuditingToolReportResponseResetStart = () => ({
	type: AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET,
});

export const getAuditingToolReportResponseChanged = () => ({
	type: AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED,
});

/** ***************** AUDITING TOOL REPORT REPORT END *********************** */
